import { UserView } from '@pages/user-view/user-view-routes.names';

export const PastAppointments = 'past-appointments';

export const UserViewPastAppointments = `/${UserView}/${PastAppointments}`;
